import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../../store/hooks";

const CornerBanner = () => {
    const AvailablePackages=useAppSelector((s)=>s?.User?.availablePackages)
  return (
    <Box
      sx={{
        position: "absolute",
        top: 3,
        right: -35,
        transform: "rotate(16deg)",
        width: 198,
        height: 40,
        background: "linear-gradient(90deg, #0568E0 0%, #12B6EA 52.07%, #65829C 101.11%)",
        clipPath: `
        polygon(
            0px 0%,           /* Top-left inner */
            calc(100% - 0px) 0%, /* Top-right inner */
            89% 50%,          /* Right notch tip */
            calc(100% - 0px) 100%, /* Bottom-right inner */
            0px 93%,         /* Bottom-left inner */
            11% 50%             /* Left notch tip */
          )
        `,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFF",
        boxShadow: 3,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "25px",
          letterSpacing: " 0.1px",
        }}
      >
        Save ${AvailablePackages?.yearlySavings}
      </Typography>
    </Box>
  );
};

export default CornerBanner;
